<!--
    课程商品-耗课统计
    作用：展示校区中我的课程消耗情况
    功能：展示列表数据、查看详情
    组件：AppList、AppSearch
    版本号: 3.0
-->
<template>
  <div>
    <AppList
      ref="list"
      :list.sync="list"
      :columns="columnsLiveAll"
      :columns-check="columnsLive"
      :api-type="apiUrl"
      :api="apiUrl"
      :download-label="'导出搜索数据'"
      :download-loading="downloadLoading"
      title=""
      @downloadPage="downloadExcel"
      @checkedColumns="checkedColumns">
      <AppSearch
        slot="search"
        :order="{ type: 'id', name: 'desc'}"
        :search-arr="searchArrLive"
        @searchType="handlerSearch"/>
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            v-for="column in columnsLive"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :min-width="column.minWidth"
            :formatter="column.formatter"
          />
          <el-table-column
            label="操作"
            width="160px"
            class="orgin-btn"
          >
            <template slot-scope="scope">
              <el-button
                class="opt-btn"
                size="small"
                @click="editSee(scope.row.id)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>

    <el-dialog
      v-if="dialogDetail.show"
      :visible.sync="dialogDetail.show"
      title="查看详情"
      width="1000px">
      <AppList
        :list.sync="dialogDetail.list"
        :api="dialogDetail.api"
        :exit-url="false"
        title="">
        <template slot-scope="props">
          <el-table :data="props.listData">
            <el-table-column
              v-for="column in dialogDetail.column"
              :key="column.prop"
              :prop="column.prop"
              :label="column.label"
              :width="column.width"
              :formatter="column.formatter"
              align="center"
            />
          </el-table>
        </template>
      </AppList>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          type="primary"
          @click="dialogDetail.show = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ConsumptionStatistics',
  data() {
    return {
      source: null,
      list: {},
      apiUrl: '',
      id: this.$route.query.id,
      downloadLoading: false,
      columnsLive: [],
      columnsLiveAll: [
        {
          index: 0,
          label: '制作校区',
          minWidth: '100px',
          formatter: (row) => {
            const name = row.result ? row.result.clients.review_used.name : '--';
            return name;
          },
        },
        { index: 1, prop: 'school_id', label: '校区ID' },
        {
          index: 2,
          label: '校区代码',
          minWidth: '100px',
          formatter: (row) => {
            const info = row.client ? row.client : '--';
            const code = info ? info.school_code : '--';
            return code || '--';
          },
        },
        {
          index: 3,
          label: '校区名称',
          minWidth: '110px',
          formatter: (row) => {
            const info = row.clients_review_info ? row.clients_review_info : '--';
            const name = info ? info.name : '--';
            return name || '--';
          },
        },
        {
          index: 4,
          label: '校区创建时间',
          minWidth: '110px',
          formatter: (row) => {
            const info = row.client ? row.client : '--';
            const created_at = info ? info.created_at : '--';
            return created_at || '--';
          } },
        { index: 5, prop: 'number', label: '教室编号', width: '140px' },
        {
          index: 6,
          label: '上课时间',
          width: '180px',
          formatter: (row) => {
            let time = '';
            switch (row.status) {
              case 1: // 未开始 展示预设直播开始时间~--
                time = `${row.start_time} ~ --`;
                break;
              case 2: // 直播中 展示实际直播开始时间~--
                time = `${row.begin_time} ~ --`;
                break;
              case 3: // 已结束 展示实际直播开始时间~实际直播下课时间
                time = `${row.begin_time} ~ ${row.close_time}`;
                break;
              case 4: // 缺课 预设时间~--
                time = `${row.start_time} ~ --`;
                break;
              case 5: // 已取消 预设时间~--
                time = `${row.start_time} ~ --`;
                break;
              default:
                break;
            }
            return time;
          } },
        { index: 7,
          label: '上课时长',
          formatter: (row) => {
            let diff = '00:00:00';
            if (row.living_duration) {
              const time = this.$setting.setTime(row.living_duration);
              diff = `${this.timeFamate(Number(time.day || 0) * 24 + Number(time.hour))}:${time.min}:${time.sec}`;
            }
            return diff;
          },
        },
        {
          index: 8,
          label: '上课状态',
          formatter: (row) => {
            const type = {
              1: '未开始',
              2: '上课中',
              3: '已结束',
              4: '缺课',
              5: '已取消',
            };
            return type[row.status];
          } },
        {
          index: 9,
          label: '课程名称',
          width: '120px',
          formatter: (row) => {
            const park = row.course_ware_packet_auth ? row.course_ware_packet_auth.packet : '';
            const name = park ? row.course_ware_packet_auth.packet.name : '--';
            return name;
          } },
        {
          index: 10,
          label: '课程编码',
          width: '120px',
          formatter: (row) => {
            const park = row.course_ware_packet_auth ? row.course_ware_packet_auth.packet : '';

            const code = park ? row.course_ware_packet_auth.packet.code : '--';
            return code;
          },
        },
        { index: 11, prop: 'course_name', label: '课件名称', width: '120px' },
        { index: 12, prop: 'course_title', label: '课件标题', width: '120px' },
        { index: 13, prop: 'teacher_mobile', label: '上课账号', width: '120px' },
        {
          index: 14,
          label: '账号有效期',
          width: '120px',
          formatter: (row) => {
            const time = row.course_ware_packet_auth ? row.course_ware_packet_auth.auth_expire_time : '--';
            return time || '--';
          },
        },
        {
          index: 15,
          prop: 'packet_number_consume',
          label: '耗课次数',
        },
        {
          index: 16,
          label: '扣费形式',
          formatter: (row) => {
            const status = {
              0: '--',
              1: '金币',
              2: '会员',
              3: '商品',
              4: '课程包账号',
              5: '年服务',
              6: '体验期',
              7: '课程包次数',
            };
            return status[row.fee_type];
          } },
        {
          index: 17,
          label: '上课班级',
          minWidth: '120px',
          formatter: row => row.liveroom_classes || '--' },
        { index: 18, label: '班级学生数', formatter: row => row.student_count || 0 },
        { index: 19, label: '出勤', formatter: row => row.be_present || 0 },
        { index: 20, label: '有效参与学生数', formatter: row => row.present_logs || 0 },
        {
          index: 21,
          label: '上课端口',
          formatter: (row) => {
            const status = {
              6: '教师端',
              14: '教学平台',
              15: 'AI播放器',
              16: 'SDK',
            };
            return status[row.access_client_id];
          } },
        {
          index: 22,
          label: '是否录制',
          formatter: (row) => {
            const type = {
              0: '否',
              1: '是',
            };
            return type[row.is_playback];
          } },
        // { prop: 'name', label: '课题', width: '120px' },
        // { prop: 'teacher_name', label: '授课老师' },
        // { prop: 'student_count', label: '直播上课总人数' },
        // { prop: 'act_student_count', label: '直播上课学生数' },
        // {
        //   label: '上课类型',
        //   formatter: (row) => {
        //     const type = {
        //       1: '班级直播间',
        //       2: '链接直播间',
        //       3: '线下课',
        //     };
        //     return type[row.type];
        //   } },
        // { prop: 'course_type_text', label: '选课类型' },
        // { prop: 'bill_course_amount', label: '消耗金币' },
      ],
      excelFiles: { // excel导出文件参数对应
        0: 'make_school', // 制作校区
        1: 'school_id', // 校区ID
        2: 'school_code', // 校区代码
        3: 'school_name', // 校区名称
        4: 'school_created_at', // 校区创建时间
        5: 'number', // 教室编号
        6: 'live_time', // 上课时间
        7: 'living_duration', // 上课时长
        8: 'live_status', // 上课状态
        9: 'packet_name', // 课程名称
        10: 'packet_code', // 课程编码
        11: 'course_name', // 课件名称
        12: 'course_title', // 课件标题
        13: 'teacher_mobile', // 上课账号
        14: 'account_period', // 账号有效期
        15: 'number_consume', // 耗课次数
        16: 'fee_type', // 扣费形式
        17: 'liveroom_classes', // 上课班级
        18: 'student_count', // 班级学生数
        19: 'be_present', // 出勤
        20: 'effective_student', // 有效参与学生数
        21: 'access_client', // 上课端口
        22: 'is_playback', // 是否录制
      },
      dialogDetail: {
        show: false,
        list: {},
        column: [
          {
            prop: 'action',
            label: '操作动作',
            formatter: (row) => {
              const action = {
                1: '进入直播间',
                2: '退出直播间',
                3: '开始直播',
                4: '结束直播',
                5: '取消直播',
              };
              return action[row.action];
            },
          },
          { prop: 'created_at', label: '时间点' },
          {
            label: '直播时长（时分秒）',
            formatter: (row) => {
              const time = this.$setting.setTime(row.liveroom_second);
              return row.action === 4 ? `${this.timeFamate(Number(time.day || 0) * 24 + Number(time.hour))}:${time.min}:${time.sec}` : '00:00:00';
            },
          },
          { prop: 'act_student_count', label: '上课总人次' },
        ],
      },

      topData: {},

      searchList: {
        type: [
          { value: 1, name: '未开始' },
          { value: 2, name: '上课中' },
          { value: 3, name: '已结束' },
          { value: 4, name: '缺课' },
          { value: 5, name: '已取消' },
        ],
        access_client_id: [
          { value: 6, name: '教师端' },
          { value: 14, name: '教学平台' },
          { value: 15, name: 'AI播放器' },
          { value: 16, name: 'SDK' },
        ],
      },
    };
  },
  computed: {
    searchArrLive() {
      const column = [
        { prop: 'auth_packet_name', label: '课程名称' },
        { prop: 'name', label: '课件名称' },
        // { prop: 'teacher_name', label: '授课老师' },
        { prop: 'teacher_mobile', label: '上课账号' },
        { prop: 'search_school_name', label: '校区名称' },
      ];
      return [
        {
          componentType: 'AppSearchDate',
          searchType: 'created_at',
        },
        {
          selectValue: this.searchList.type,
          componentType: 'AppSearchStatus',
          searchType: 'status',
          placeholder: '请选择上课状态',
        },
        {
          selectValue: this.searchList.access_client_id,
          componentType: 'AppSearchStatus',
          searchType: 'access_client_id',
          placeholder: '请选择上课端口',
        },
        { componentType: 'AppSearchColumn', searchType: column },
      ];
    },
  },
  created() {
    this.apiUrl = '/api/liveroom?order[created_at]=desc&is_show_teacher=1';
    this.initColum([1, 4, 5, 10, 12, 14, 18, 19, 20, 22]);
  },
  methods: {
    initColum(indexOff) {
      const initColumn = [];
      this.columnsLiveAll.forEach((item) => {
        if (indexOff.indexOf(item.index) === -1) {
          initColumn.push(item);
        }
      });
      this.columnsLive = initColumn;
    },
    timeFamate(num) {
      return num > 9 ? num : `0${num}`;
    },
    editSee(_id) {
      this.dialogDetail.api = `/api/liveroom/teacher/action/${_id}`;
      this.dialogDetail.show = true;
    },

    // 选择列表字段
    checkedColumns(val) {
      const data = [];
      val.forEach((item) => {
        this.columnsLiveAll.forEach((v) => {
          if (v.label === item) {
            data.push(v);
          }
        });
      });
      data.sort((a, b) => a.index - b.index);
      this.$nextTick(() => {
        this.columnsLive = data;
      });
    },
    // 导出数据
    downloadExcel() {
      this.source = axios.CancelToken.source();
      const filesArr = [];
      this.columnsLive.forEach((v) => {
        filesArr.push(this.excelFiles[v.index]);
      });
      const flies = filesArr.join();
      this.downloadLoading = true;
      const query = Object.keys(this.$route.query)
        .map(key => `${key}=${this.$route.query[key]}`)
        .join('&');
      this.$http.get(`/api/liveroom?order[created_at]=desc&is_show_teacher=1&action=export_excel&${query}&excel_fields=${flies}`, {
        responseType: 'blob',
        cancelToken: this.source.token }).then((res) => {
        this.downloadLoading = false;
        this.$setting.saveAs(res, '耗课统计');
      }).catch((err) => {
        if (err.message.includes('timeout')) {
          this.$message.error('数据量过大，下载失败！请限制数据量，重新下载！');
        } else {
          this.$message.error(err.message);
        }
        this.downloadLoading = false;
      });
    },
    handlerSearch() {
      this.downloadLoading = false;
      this.source.cancel('下载失败！');
    },
  },
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/CourseGoods/ConsumptionStatistics/index.vue